import { PartnerPlatformSalesReport } from '../PartnerPlatformSalesReport/PartnerPlatformSalesReport';

export interface SalesReport extends PartnerPlatformSalesReport {
  totalOrders: number;
  totalProducts: number;
  totalSubTotal: number;
  totalShippingCost: number;
  totalDiscount: number;
}

export const salesReportFromResponse = (responseData: any): SalesReport => ({
  createdAt: new Date(responseData.created_at),
  totalOrders: responseData.total_orders,
  totalProducts: responseData.total_products,
  totalSubTotal: responseData.total_sub_total,
  totalShippingCost: responseData.total_shipping_cost,
  totalDiscount: responseData.total_discount,
  total: responseData.total,
});
